import { observable, action, toJS } from "mobx";
import {
  userlogin,
  userRregister,
  PeoplefindAllPageable,
  PeoplefindOne,
  Myask,
  Allqustion,
  findAll,
  GetGroupId,
  guideDetail,
} from "../static/js/http";
import home from "../store/index";
import { setCookie, getCookie } from "../static/js/utils";
class Home {
  @observable list = "";
  @observable isExisted = false; //是否第一次登录
  @observable userId = ""; //用户id
  @observable loginSecond = false; //第一次登录后选择注册
  // 搜索页面
  @observable searchKeyWord = "";
  @observable allquestion = [];
  @observable onequestion = "";
  @observable HotList = [];
  @observable tagVal = ""; //搜索页快速选择分类
  // 我的信箱
  @observable MyEmailList = [];
  @observable unReadnum = 0;
  @observable MyShowId = "";

  // 我要提问页面
  @observable askLoad = false;
  @observable askLoadShow = false; //提问中。。.
  @observable askSuccess = false; //提问成功
  @observable askerror = false; //网络错误
  @observable num = ""; // 我的问题
  @observable circle = false; //是否要马甲
  // 解忧人
  @observable personList = []; //解忧人列表
  @observable persontotalElements = "";
  @observable persontotalPages = "";
  @observable personOneId = 25;
  // 解忧人详情
  @observable peopleDetail = {};
  //loading 组件的展示
  @observable isLoading = false;

  // 主页单个问题展开
  @observable showId = "";
  allTagQuestions = {}; //所有问题列表
  @observable OnceTagAllQuestion = []; // 第一次获取全部标签问题数据
  @observable OncePeople = []; // 第一次获取解忧人列表
  @observable OnceMyQuestion = []; // 第一次获取我的问题列表
  @observable OnceHot = []; // 第一次获取热问题列表
  AllParams = {
    // 所以请求共有参数
    page: 0,
    size: 20,
  };
  @observable groupId = null; //当前解忧人所归属的解忧人群组
  @observable isGroup = false;
  @observable AnswerSubmit = {
    //回答的当前问题
    title: "",
  };
  @observable AnswerList = []; //未回答问题列表
  @observable titlenum = ""; //回答问题的title
  @observable Answer = ""; //未回答问题
  // 专家指南
  @observable guideDetailData = [];

  // 根据tag筛选热门问题
  @action.bound
  selectTag(name) {
    this.tagVal = name;
  }
  @action.bound
  setHotList(data) {
    this.HotList = data;
  }

  // 热门问题
  @action.bound
  HotAll() {
    let params = {
      isHot: true,
      isAnswered: true,
      type: "client",
    };
    findAll(params)
      .then((res) => {
        if (res.msg === "success") {
          this.HotList = res.data;
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
      })
      .catch((err) => {});
  }

  @action
  serchKeyWords(val) {
    this.searchKeyWord = val;
    if (this.searchKeyWord !== "") {
      this.allquestionShow = false;
    } else {
      this.allquestionShow = true;
    }
  }
  @action
  ChangeOnequestion(val) {
    this.onequestion = val;
  }

  // 我的信箱问题
  @action.bound
  MyEmailqestion() {
    let params = {
      page: 0,
      size: 10,
      userId: getCookie("userId"),
    };
    Allqustion(params)
      .then((res) => {
        if (res.msg === "success") {
          this.MyEmailList = res.data.pageData;
        }
      })
      .catch((err) => {});
  }
  //单个解忧人
  @action.bound
  PeoplefindOne() {
    PeoplefindOne(this.personOneId)
      .then((res) => {})
      .catch((err) => {});
  }

  // 登录
  @action.bound
  login() {
    this.isLoading = true;
    userlogin()
      .then((res) => {
        if (res.msg === "success") {
          this.isExisted = res.data.isExisted;
          this.userId = res.data.id;
          setCookie("userId", res.data.id);
          if (this.isExisted) {
            this.isLoading = false;
          }
        } else {
          if (!this.isExisted) {
            this.isLoading = false;
          }
        }
      })
      .catch((err) => {
        console.log(err, "登录接口");
      });
  }
  // 获取解忧人组id
  GetGroupId() {
    GetGroupId().then((res) => {
      if (res.data) {
        this.groupId = res.data;
        this.isGroup = true;
      } else {
        this.isGroup = false;
      }
    });
  }
  // 注册页面显示
  @action.bound
  secoedlogin(val) {
    this.loginSecond = val;
  }
  // 注册用户
  @action.bound
  register(data) {
    userRregister(data)
      .then((res) => {
        if (res.msg === "success") {
          this.login();
          this.loginSecond = false;
        } else {
        }
      })
      .catch((err) => {});
  }

  // 我的提问
  @action.bound
  Myaskq(data, isalias, alias) {
    let params;
    params = { userId: getCookie("userId"), question: data, alias: alias };
    Myask(params)
      .then((res) => {
        if (res.msg === "success") {
          this.askSuccess = true;
          this.askLoadShow = false;
          setTimeout(() => {
            this.askSuccess = false;
            this.askLoad = false;
            this.num = "";
            home.circle = false;
          }, 1000);
        } else {
          this.askLoad = false;
          this.askLoadShow = false;
          this.askSuccess = false;
          this.askerror = true;
          setTimeout(() => {
            this.askerror = false;
          }, 1000);
        }
      })
      .catch((err) => {
        this.askLoad = false;
        this.askerror = true;
        setTimeout(() => {
          this.askerror = false;
        }, 1000);
      });
  }

  // 第一次获取全部问题
  @action.bound
  getOnceAllTagQuestion() {
    let data = {
      ...this.AllParams,
      isAnswered: true,
      isHot: true,
      type: 1,
    };
    Allqustion(data)
      .then((res) => {
        if (res.msg === "success") {
          this.OnceTagAllQuestion = res.data;
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }
      })
      .catch((err) => {});
  }
  // 第一次获取解忧人列表
  @action.bound
  getOncePeoples() {
    PeoplefindAllPageable(this.AllParams)
      .then((res) => {
        if (res.msg === "success") {
          this.OncePeople = res.data && res.data;
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }
      })
      .catch((err) => {});
  }
  // 第一次获取信箱问题列表
  @action.bound
  getOnceMyEmail() {
    let data = {
      ...this.AllParams,
      userId: getCookie("userId"),
    };
    Allqustion(data)
      .then((res) => {
        if (res.msg === "success") {
          this.OnceMyQuestion = res.data && res.data;
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }
      })
      .catch((err) => {});
  }

  // 获取初始化数据
  @action.bound
  getAllData() {
    // 第一次获取全部问题
    // this.getOnceAllTagQuestion();
    // 第一次获取解忧人列表
    // this.getOncePeoples();
    // 第一次获取信箱问题列表
    // this.getOnceMyEmail();
    // 热门问题
    // this.HotAll();
  }

  @action.bound
  ChangeJs(val) {
    return toJS(val);
  }
  // 获取专家指南详情
  @action.bound
  getGuideDetail(data) {
    guideDetail(data.data)
      .then((res) => {
        this.guideDetailData = res.data;
        data.cb && data.cb();
      })
      .catch((err) => {
        console.log(err, "接口失败");
      });
  }

  // 获取当前解忧人要回答的问题列表
  @action.bound
  getAnswerList() {
    let data = {
      page: 0,
      size: 100,
      userId: getCookie("userId"),
      isHot: false,
      isAnswered: false,
      groupId: this.ajaxGroupId,
    };
    Allqustion(data)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }
}

export default new Home();
